// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.form {\n  padding: 10px;\n  background: #ffffff;\n}\n.submit-button {\n  width: 90%;\n}\n.v-input--switch .v-input--switch__track {\n  color: #424242 !important;\n}\n", ""]);
// Exports
module.exports = exports;
